import React, { useState } from "react";
import emailjs from "emailjs-com";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../FirebaseComp/firebase";
import "./body.css";

function Body() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    institutionName: "",
    brNo: "",
    establishedDate: "",
    address: "",
    telephone: "",
    email: "",
    website: "",
    divisionalSecretary: "",
    district: "",
    province: "",
    contactPerson: "",
    contactAddress: "",
    contactPhone: "",
    position: "",
    qualification: "",
    institutionType: {
      retailOptical: false,
      wholesale: false,
      investor: false,
      other: false,
      otherSpecify: ""
    },
    infrastructure: {},
    amenities: {}
  });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setFormData({
      institutionName: "",
      brNo: "",
      establishedDate: "",
      address: "",
      telephone: "",
      email: "",
      website: "",
      divisionalSecretary: "",
      district: "",
      province: "",
      contactPerson: "",
      contactAddress: "",
      contactPhone: "",
      position: "",
      qualification: "",
      institutionType: {
        retailOptical: false,
        wholesale: false,
        investor: false,
        other: false,
        otherSpecify: ""
      },
      infrastructure: {},
      amenities: {}
    });
  };

  // HANDLE INPUT CHANGE
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === "checkbox") {
      if (name.includes("institutionType.")) {
        const field = name.split(".")[1];
        setFormData({
          ...formData,
          institutionType: {
            ...formData.institutionType,
            [field]: checked
          }
        });
      } else {
        setFormData({
          ...formData,
          [name]: checked
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  // HANDLE INFRASTRUCTURE CHANGE
  const handleInfrastructureChange = (item, field, value) => {
    setFormData({
      ...formData,
      infrastructure: {
        ...formData.infrastructure,
        [item]: {
          ...formData.infrastructure[item],
          [field]: value
        }
      }
    });
  };

  // HANDLE AMENITIES CHANGE
  const handleAmenitiesChange = (amenity, field, value) => {
    setFormData({
      ...formData,
      amenities: {
        ...formData.amenities,
        [amenity]: {
          ...formData.amenities[amenity],
          [field]: value
        }
      }
    });
  };

  // 🔥 FULL HANDLE SUBMIT (SAVE + EMAIL)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // 1️⃣ SAVE TO FIRESTORE
      await addDoc(collection(db, "optica-memberships"), {
        ...formData,
        createdAt: Timestamp.now()
      });

      // 2️⃣ SEND EMAIL USING EMAILJS
     await emailjs.send(
  "service_f5biz1g",
  "template_z0p1yu7",
  {
    institutionName: formData.institutionName,
    brNo: formData.brNo,
    establishedDate: formData.establishedDate,
    address: formData.address,
    telephone: formData.telephone,
    email: formData.email,
    website: formData.website,
    divisionalSecretary: formData.divisionalSecretary,
    district: formData.district,
    province: formData.province,
    contactPerson: formData.contactPerson,
    contactAddress: formData.contactAddress,
    contactPhone: formData.contactPhone,
    position: formData.position,
    qualification: formData.qualification,
    institutionType: Object.entries(formData.institutionType)
      .filter(([key, value]) => key !== "otherSpecify" && value)
      .map(([key]) => key)
      .concat(formData.institutionType.otherSpecify ? [formData.institutionType.otherSpecify] : [])
      .join(", ")
  },
  "0tqu3JXAHOi2utnXT"
);

      alert("Registration submitted successfully!");
      closeModal();
    } catch (error) {
      console.error("Submission Error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="landing">
      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-content">
          <h1>Optica International</h1>
          <p>Advanced Clinical Diagnostic Equipment Solutions</p>
          <a href="#membership" className="primary-btn">Membership Open</a>
        </div>
      </section>

      {/* About Us */}
      <section id="about" className="section about">
        <h2>About Us</h2>
        <p>
          Optica International specializes in supplying high-quality
          clinical diagnostic equipment for hospitals, eye clinics,
          laboratories, and medical professionals. We are committed to
          precision, innovation, and reliability in healthcare technology.
        </p>

        <div className="features">
          <div className="feature-card">✔ Clinical Diagnosis Equipment</div>
          <div className="feature-card">✔ Trusted Medical Technology</div>
          <div className="feature-card">✔ Professional Support</div>
        </div>
      </section>

      {/* NEW: Benefits Section */}
      <section id="benefits" className="section benefits">
        <h2>Benefits of Optica International Membership</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">💰</div>
            <h3>Reduce Your Cost of Purchase</h3>
            <p>Save more with exclusive member pricing and bulk purchase discounts on all diagnostic equipment and supplies.</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">🏥</div>
            <h3>Improve Your Practice Place</h3>
            <p>Get expert guidance on optimizing your optical practice layout, workflow, and professional environment.</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">📈</div>
            <h3>Promote Your Business</h3>
            <p>Increase your visibility through our professional network, referrals, and marketing support programs.</p>
          </div>
        </div>
      </section>

      {/* Membership */}
      <section id="membership" className="section membership">
        <h2>Membership Registration</h2>
        <p>
          Join Optica International and gain access to exclusive products,
          technical support, training updates, and special pricing.
        </p>

        <div className="membership-box">
          <h3>Membership Open</h3>
          <p>Register today to be part of our professional medical network.</p>
          <button className="primary-btn" onClick={openModal}>Register Now</button>
        </div>
      </section>

      {/* Registration Modal - Enhanced Form */}
      <div className={`register-modal ${isModalOpen ? 'active' : ''}`}>
        <div className="modal-content modal-lg">
          <button className="close-modal" onClick={closeModal}>&times;</button>
          
          <form className="registration-form" onSubmit={handleSubmit}>
            <h3>Membership Registration</h3>
            
            {/* Institution Details */}
            <div className="form-section">
              <h3>Institution Details</h3>
              <div className="form-row">
                <input 
                  type="text" 
                  name="institutionName"
                  value={formData.institutionName}
                  onChange={handleChange}
                  placeholder="Name of the Institution *" 
                  required 
                />
              </div>
              <div className="form-row">
                <input 
                  type="text" 
                  name="brNo"
                  value={formData.brNo}
                  onChange={handleChange}
                  placeholder="Business Registration (BR) No:" 
                />
                <input 
                  type="date" 
                  name="establishedDate"
                  value={formData.establishedDate}
                  onChange={handleChange}
                  placeholder="Date of Establishment:"  
                />
              </div>
              <div className="form-row">
                <input 
                  type="text" 
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Address of the Institution *" 
                  required 
                />
              </div>
              <div className="form-row">
                <input 
                  type="tel" 
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleChange}
                  placeholder="Telephone No:" 
                />
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email: *" 
                  required 
                />
                <input 
                  type="text" 
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  placeholder="Website:" 
                />
              </div>
              <div className="form-row">
                <input 
                  type="text" 
                  name="divisionalSecretary"
                  value={formData.divisionalSecretary}
                  onChange={handleChange}
                  placeholder="Divisional Secretary:" 
                />
                <input 
                  type="text" 
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  placeholder="District:" 
                />
                <input 
                  type="text" 
                  name="province"
                  value={formData.province}
                  onChange={handleChange}
                  placeholder="Province:" 
                />
              </div>
            </div>

            {/* Person Details */}
            <div className="form-section">
              <h3>Contact Person Details</h3>
              <div className="form-row">
                <input 
                  type="text" 
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleChange}
                  placeholder="Name of the person *" 
                  required 
                />
              </div>
              <div className="form-row">
                <input 
                  type="text" 
                  name="contactAddress"
                  value={formData.contactAddress}
                  onChange={handleChange}
                  placeholder="Address:" 
                />
              </div>
              <div className="form-row">
                <input 
                  type="tel" 
                  name="contactPhone"
                  value={formData.contactPhone}
                  onChange={handleChange}
                  placeholder="Telephone No (Officials):" 
                />
              </div>
              <div className="form-row">
                <input 
                  type="text" 
                  name="position"
                  value={formData.position}
                  onChange={handleChange}
                  placeholder="Position at Institution:" 
                />
              </div>
              <div className="form-row">
                <input 
                  type="text" 
                  name="qualification"
                  value={formData.qualification}
                  onChange={handleChange}
                  placeholder="Professional Qualification:" 
                />
              </div>
            </div>

            {/* Institution Type */}
            <div className="form-section">
              <h3>Type of Institution</h3>
              <div className="checkbox-group">
                <label className="checkbox-label">
                  <input 
                    type="checkbox" 
                    name="institutionType.retailOptical"
                    checked={formData.institutionType.retailOptical}
                    onChange={handleChange}
                  /> Retail Optical
                </label>
                <label className="checkbox-label">
                  <input 
                    type="checkbox" 
                    name="institutionType.wholesale"
                    checked={formData.institutionType.wholesale}
                    onChange={handleChange}
                  /> Wholesale
                </label>
                <label className="checkbox-label">
                  <input 
                    type="checkbox" 
                    name="institutionType.investor"
                    checked={formData.institutionType.investor}
                    onChange={handleChange}
                  /> Investor
                </label>
                <label className="checkbox-label">
                  <input 
                    type="checkbox" 
                    name="institutionType.other"
                    checked={formData.institutionType.other}
                    onChange={handleChange}
                  /> Other
                  <input 
                    type="text" 
                    name="institutionType.otherSpecify"
                    value={formData.institutionType.otherSpecify}
                    onChange={handleChange}
                    placeholder="Please specify" 
                    className="other-input" 
                  />
                </label>
              </div>
            </div>

            {/* Infrastructure Table */}
            <div className="form-section">
              <h3>Infrastructure and Common Amenities</h3>
              <div className="table-responsive">
                <table className="infrastructure-table">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>No. of Units</th>
                      <th>Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {['Parking', 'Reception', 'Optical Showroom', 'Testing room', 
                      'Fitting / Glazing room', 'Office room', 'Washroom'].map((item) => (
                      <tr key={item}>
                        <td>{item}</td>
                        <td>
                          <input 
                            type="number" 
                            min="0" 
                            placeholder="0"
                            value={formData.infrastructure[item]?.units || ''}
                            onChange={(e) => handleInfrastructureChange(item, 'units', e.target.value)}
                          />
                        </td>
                        <td>
                          <input 
                            type="text" 
                            placeholder="Remark"
                            value={formData.infrastructure[item]?.remark || ''}
                            onChange={(e) => handleInfrastructureChange(item, 'remark', e.target.value)}
                          />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td>
                        <input 
                          type="text" 
                          placeholder="Other (Specify)"
                          value={formData.infrastructure.other?.name || ''}
                          onChange={(e) => handleInfrastructureChange('other', 'name', e.target.value)}
                        />
                      </td>
                      <td>
                        <input 
                          type="number" 
                          min="0" 
                          placeholder="0"
                          value={formData.infrastructure.other?.units || ''}
                          onChange={(e) => handleInfrastructureChange('other', 'units', e.target.value)}
                        />
                      </td>
                      <td>
                        <input 
                          type="text" 
                          placeholder="Remark"
                          value={formData.infrastructure.other?.remark || ''}
                          onChange={(e) => handleInfrastructureChange('other', 'remark', e.target.value)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Amenities Table */}
            <div className="form-section">
              <h3>Amenities</h3>
              <div className="table-responsive">
                <table className="amenities-table">
                  <thead>
                    <tr>
                      <th>Amenities</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Water Supply</td>
                      <td>
                        <input 
                          type="text" 
                          placeholder="Taps, Number"
                          value={formData.amenities.waterSupply?.description || ''}
                          onChange={(e) => handleAmenitiesChange('waterSupply', 'description', e.target.value)}
                        />
                        <span className="table-note">
                          Total number in order: 
                          <input 
                            type="number" 
                            placeholder="0"
                            value={formData.amenities.waterSupply?.total || ''}
                            onChange={(e) => handleAmenitiesChange('waterSupply', 'total', e.target.value)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Ventilation</td>
                      <td>
                        <input 
                          type="text" 
                          placeholder="Windows / Doors"
                          value={formData.amenities.ventilation?.description || ''}
                          onChange={(e) => handleAmenitiesChange('ventilation', 'description', e.target.value)}
                        />
                        <span className="table-note">
                          Doors: 
                          <input 
                            type="number" 
                            placeholder="0"
                            value={formData.amenities.ventilation?.doors || ''}
                            onChange={(e) => handleAmenitiesChange('ventilation', 'doors', e.target.value)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Lighting</td>
                      <td>
                        <input 
                          type="text" 
                          placeholder="Number of Lights / Natural Light"
                          value={formData.amenities.lighting?.description || ''}
                          onChange={(e) => handleAmenitiesChange('lighting', 'description', e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Safety</td>
                      <td>
                        <input 
                          type="text" 
                          placeholder="Safety measures"
                          value={formData.amenities.safety?.description || ''}
                          onChange={(e) => handleAmenitiesChange('safety', 'description', e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>First Aid</td>
                      <td>
                        <input 
                          type="text" 
                          placeholder="First aid facilities"
                          value={formData.amenities.firstAid?.description || ''}
                          onChange={(e) => handleAmenitiesChange('firstAid', 'description', e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Fire Protection</td>
                      <td>
                        <input 
                          type="text" 
                          placeholder="Fire safety equipment"
                          value={formData.amenities.fireProtection?.description || ''}
                          onChange={(e) => handleAmenitiesChange('fireProtection', 'description', e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Garbage/Waste Disposal</td>
                      <td>
                        <input 
                          type="text" 
                          placeholder="Disposal method"
                          value={formData.amenities.wasteDisposal?.description || ''}
                          onChange={(e) => handleAmenitiesChange('wasteDisposal', 'description', e.target.value)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="">
              <button 
                type="submit" 
                className="primary-btn" 
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Registration'}
              </button>
              <button 
                type="button" 
                className="secondary-btn" 
                onClick={closeModal}
                disabled={isSubmitting}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Contact Us */}
      <section id="contact" className="section contact">
        <h2>Contact Us</h2>

        <div className="contact-details">
          <p><strong>Address:</strong> 932, Maradana Road, Colombo 08</p>
          <p><strong>Contact No:</strong> 076 136 0946</p>
        </div>

        <form className="contact-form" onSubmit={(e) => {
          e.preventDefault();
          alert('Message sent successfully!');
        }}>
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" rows="4"></textarea>
          <button type="submit" className="primary-btn">Send Message</button>
        </form>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} Optica International. All Rights Reserved.</p>
      </footer>
    </div>
  );
}

export default Body;